/**
 * @generated SignedSource<<e191fe8f978a91a8364f661a75b25c8f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_FullPageIssueApp_issueResults$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly key: string;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueAppWithData_issueResults">;
  readonly " $fragmentType": "main_issueNavigator_FullPageIssueApp_issueResults";
};
export type main_issueNavigator_FullPageIssueApp_issueResults$key = {
  readonly " $data"?: main_issueNavigator_FullPageIssueApp_issueResults$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_FullPageIssueApp_issueResults">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_FullPageIssueApp_issueResults",
  "selections": [
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "key"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_IssueAppWithData_issueResults"
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "c76ea1c159a6e1be56c13b6262324ca3";

export default node;
